import React, { useState, useContext } from 'react'; 
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { logIn } from './cognitoUtils'; 
import { signUp } from './cognitoUtils';
import './Auth.css'

//Login and Signup page
const Auth = () => {
  const { user, setUser, setIdToken, setS3, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [page, setPage] = useState(true)
  const [loading, isLoading] = useState(false)

  const { from } = location.state || { from: { pathname: '/' } };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      isLoading(true)
      await logIn(username, password, setUser, setIdToken, setS3, logout);
      isLoading(false)
      navigate(from); 
    } catch (error) {
      isLoading(false)
      setMessage(error.message || 'Login failed.');
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      await signUp(username, email, password);
      setMessage('Signup successful! Check your email confirmation.');
      navigate(`/verifyaccount?username=${username}`);
    } catch (error) {
      setMessage(error.message || 'Signup failed.');
    }
  };

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="wrapper">
      <div className="title-text">
        <div className={`title ${page ? 'login' : 'signup'}`}>
          {page ? 'Login Form' : 'Signup Form'}
        </div>
      </div>
      <div className="form-container">
        <div className="slide-controls">
          <input
            type="radio"
            name="slide"
            id="login"
            checked={page}
            onChange={() => {
              setUsername('')
              setEmail('')
              setPassword('')
              setPage(true)
              }}
          />
          <input
            type="radio"
            name="slide"
            id="signup"
            checked={!page}
            onChange={() => {
              setUsername('')
              setEmail('')
              setPassword('')
              setPage(false)
              }}
          />
          <label htmlFor="login" className="slide login">
            Login
          </label>
          <label htmlFor="signup" className="slide signup">
            Signup
          </label>
          <div className="slider-tab"></div>
        </div>
        <div className="form-inner">
          {page ? (
            <form onSubmit={handleLogin} className="login">
              <div className="field">
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Username"
                  required
                />
              </div>
              <div className="field">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                />
              </div>
              <p className='error-message'>{message}</p>
              {loading && (<div class="loader"></div>)}
              <div className="pass-link">
                <a href="/forgetpassword">Forgot password?</a>
              </div>
              <div className="field btn">
                <div className="btn-layer"></div>
                <input type="submit" value="Login" />
              </div>
              <div className="signup-link">
                Create an account?{' '}
                <a href="#" onClick={() => setPage(false)}>
                  Signup now
                </a>
              </div>
            </form>
          ) : (
            <form onSubmit={handleSignup} className="signup">
              <div className="field">
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Username"
                  required
                />
              </div>
              <div className="field">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  required
                />
              </div>
              <div className="field">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                />
              </div>
              <p className='error-message'>{message}</p>
              <div className="field btn">
                <div className="btn-layer"></div>
                <input type="submit" value="Signup" />
              </div>
              <div className="signup-link">
                Already have an account?{' '}
                <a href="#" onClick={() => setPage(true)}>
                  Login
                </a>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>


    
  );
};

export default Auth;
